import { useAuthStore } from '@/store/auth.store';
import type { AppUser } from '@/types/domain';

export function useCurrentUser(): AppUser | null {
  return useAuthStore((s) => s.user);
}
